var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import ThirdPartyModal from '@declaration/components/thirdParty/ThirdPartyModal.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
const thirdParty = namespace('thirdParty');
const pages = namespace('pages');
let FireHasProfessionalInfoQuestion = class FireHasProfessionalInfoQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
        this.isModalOpen = false;
    }
    get thirdPartyPayload() {
        return {
            step: this.step,
            fireDamageQualification: {
                id: this.fireDamageQualification.id,
                hasThirdPartyInfo: this.selectedValue,
            },
        };
    }
    get formTitleModal() {
        if (this.previousStep === 'qualification/incendie/depart-du-feu') {
            return this.$tc('claim.qualification.fire_third_party_neighboor.subform_title');
        }
        else if (this.previousStep === 'qualification/incendie/origine-parties-communes') {
            return this.$tc('claim.qualification.third_party_company.subform_title');
        }
        else {
            return this.$tc('claim.qualification.fire_third_party_crim_act.subform_title');
        }
    }
    get panelTitle() {
        if (this.previousStep === 'qualification/incendie/depart-du-feu') {
            return this.$tc('claim.qualification.fire_third_party_neighboor.question_title');
        }
        else if (this.previousStep === 'qualification/incendie/origine-parties-communes') {
            return this.$tc('claim.qualification.third_party_company.title');
        }
        else {
            return this.$tc('claim.qualification.fire_third_party_crim_act.title');
        }
    }
    get sidebarTitle() {
        let key;
        if (this.previousStep === 'qualification/incendie/depart-du-feu') {
            key = 'claim.qualification.fire_third_party_neighboor.question_sidebar_title';
        }
        else if (this.previousStep === 'qualification/incendie/origine-parties-communes') {
            key = 'claim.qualification.third_party_company.sidebar_title';
        }
        else {
            key = 'claim.qualification.fire_third_party_crim_act.sidebar_title';
        }
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get headerTitleModal() {
        return this.$tc('claim.qualification.fire_third_party_crim_act.form_title');
    }
    get selectedValue() {
        return this.fireDamageQualification.hasThirdPartyInfo;
    }
    handleButtonClick(hasThirdPartyInfo) {
        if (hasThirdPartyInfo === false) {
            this.updateAndSaveQualification({
                qualificationPayload: { hasThirdPartyInfo },
                step: this.step,
            });
        }
        else {
            if (this.thirdParties.length === 0)
                this.addNewThirdPartyAndEditIt(false);
            else
                this.setThirdPartyInEditionIndex(0);
            this.updateQualification({
                qualificationPayload: { hasThirdPartyInfo },
            });
            this.isModalOpen = true;
        }
    }
    get answer() {
        if (this.fireDamageQualification.hasThirdPartyInfo === null) {
            return null;
        }
        if (this.fireDamageQualification.hasThirdPartyInfo)
            return this.$tc('claim.qualification.fire.has_third_party_info.answer');
        return this.$tc('claim.qualification.fire.has_not_third_party_info.answer');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireHasProfessionalInfoQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    pages.Getter('previousStep')
], FireHasProfessionalInfoQuestion.prototype, "previousStep", void 0);
__decorate([
    qualification.State('qualification')
], FireHasProfessionalInfoQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireHasProfessionalInfoQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireHasProfessionalInfoQuestion.prototype, "updateQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireHasProfessionalInfoQuestion.prototype, "selectedContract", void 0);
__decorate([
    thirdParty.Action('addNewThirdPartyAndEditIt')
], FireHasProfessionalInfoQuestion.prototype, "addNewThirdPartyAndEditIt", void 0);
__decorate([
    thirdParty.Action('setThirdPartyInEditionIndex')
], FireHasProfessionalInfoQuestion.prototype, "setThirdPartyInEditionIndex", void 0);
__decorate([
    thirdParty.State('thirdParties')
], FireHasProfessionalInfoQuestion.prototype, "thirdParties", void 0);
FireHasProfessionalInfoQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel, ThirdPartyModal },
        props: QuestionProps,
    })
], FireHasProfessionalInfoQuestion);
export default FireHasProfessionalInfoQuestion;
